import React from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import { Asset, Link } from "../../../../plugins/gatsby-plugin-atollon"
import StructuredText from "../custom-structured-text-renderer"
import { RightArrow } from "../../icons"

const TitleContentSticky = ({ title, richContent, items }) => {
  return (
    <section className="title-content-sticky">
      <div className="title-content-sticky__inner">
        <div
          className="title-content-sticky__title"
          data-sal="slide-up"
          data-sal-duration="1000"
          data-sal-easing="ease"
        >
          {title && <h2>{parse(title)}</h2>}
          {richContent && <StructuredText data={richContent} />}
        </div>

        {items?.length > 0 && (
          <div className="title-content-sticky__items">
            <div className="image">
              {items.map((item, index) => (
                <div key={index} className="title-content-sticky__item">
                  {item.image && (
                    <div className="title-content-sticky__item-image">
                      <Asset asset={item.image} />
                    </div>
                  )}
                  <div className="title-content-sticky__item-body">
                    {item.icon && (
                      <div className="title-content-sticky__item-icon">
                        <Asset asset={item.icon} />
                      </div>
                    )}

                    {item.title && <h3>{parse(item.title)}</h3>}
                    {item.richContent && (
                      <StructuredText data={item.richContent} />
                    )}

                    {item.link?.length > 0 && (
                      <ul className="title-content-sticky__item-links">
                        {item.link.map((el, i) => (
                          <li key={i}>
                            <Link
                              to={
                                el.link?.[0]?.externalLink
                                  ? el.link[0].externalLink
                                  : el.link?.[0]?.internalLink?.permalink
                              }
                            >
                              {el.title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div className="content">
              {items.map((item, index) => (
                <div key={index} className="title-content-sticky__wrapper">
                  <div className="title-content-sticky__item-body">
                    {item.icon && (
                      <div className="title-content-sticky__item-icon">
                        <Asset asset={item.icon} />
                      </div>
                    )}

                    {item.title && <h3>{parse(item.title)}</h3>}
                    {item.richContent && (
                      <StructuredText data={item.richContent} />
                    )}

                    {item.link?.length > 0 && (
                      <ul className="title-content-sticky__item-links">
                        {item.link.map((el, i) => (
                          <li key={i}>
                            <Link
                              to={
                                el.link?.[0]?.externalLink
                                  ? el.link[0].externalLink
                                  : el.link?.[0]?.internalLink?.permalink
                              }
                            >
                              {el.title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  )
}

export default TitleContentSticky

export const query = graphql`
  fragment TitleContentStickyProps on DatoCmsTitleContentSticky {
    ... on DatoCmsTitleContentSticky {
      id
      title
      richContent {
        value
      }
      items {
        title
        richContent {
          value
        }
        image {
          ...InternalAssetProps
        }
        icon {
          ...InternalAssetProps
        }
        link {
          ...LinkWithTitleProps
        }
      }
    }
  }
`

//  <div className="title-content-sticky__inner">
//         <div className="title-content-sticky__header" data-sal="slide-up" data-sal-duration="1000" data-sal-easing="ease">
//           {title && <h2>{parse(title)}</h2>}
//           {richContent && <StructuredText data={richContent} />}
//         </div>

//         {items?.length > 0 && (
//           <div className="title-content-sticky__items">
//             {items.map((item, index) => (
//               <article
//                 key={index}
//                 className="title-content-sticky__item"
//                 data-sal="slide-up"
//                 data-sal-duration="1000"
//                 data-sal-easing="ease"
//               >
//                 {item.image && (
//                   <div className="title-content-sticky__item-image">
//                     <Asset asset={item.image} />
//                   </div>
//                 )}

//                 <div className="title-content-sticky__item-body">
//                   {item.icon && (
//                     <div className="title-content-sticky__item-icon">
//                       <Asset asset={item.icon} />
//                     </div>
//                   )}

//                   {item.title && <h3>{parse(item.title)}</h3>}
//                   {item.richContent && <StructuredText data={item.richContent} />}

//                   {item.link?.length > 0 && (
//                     <ul className="title-content-sticky__item-links">
//                       {item.link.map((el, i) => (
//                         <li key={i}>
//                           <Link
//                             to={
//                               el.link?.[0]?.externalLink
//                                 ? el.link[0].externalLink
//                                 : el.link?.[0]?.internalLink?.permalink
//                             }
//                           >
//                             {el.title}
//                           </Link>
//                         </li>
//                       ))}
//                     </ul>
//                   )}
//                 </div>
//               </article>
//             ))}
//           </div>
//         )}
//       </div>
